import { NonDependantFlexCodes } from '@/enums';

/**
 * Gets the non-dependant keys from NonDependantFlexCodes enum.
 * Replaces the undescores with spaces
 * @returns {Object[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function getNonDependantList() {
  const nonDependantList = Object.keys(NonDependantFlexCodes).map((str) => {
    return str.replace(/_/i, ' ');
  });

  return nonDependantList;
}
